import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    TextInput,
    required,
    BooleanInput,
    NumberInput
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { currency, frequency } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const SubscriptionProductPriceCreate: () => JSX.Element = (): JSX.Element => {

    return (
        <Create>
            <SimpleForm >
                <NumberInput source="price" name="price" />
                <SelectInput source="currency" name="currency" choices={ currency } />
                <NumberInput source="priceFrequencyCount"
                             name="priceFrequencyCount"
                             defaultValue={1} />
                <SelectInput source="priceFrequency"
                             name="priceFrequency"
                             defaultValue="month"
                             choices={ frequency } />
                <BooleanInput source="active" name="active" />
                <BooleanInput source="defaultPrice" name="defaultPrice" />
                <ReferenceInput source="subscriptionProduct" reference="subscription_products"  >
                    <SelectInput validate={ [required()] } />
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
